import {FIELD_BIOME_LAYER_KEYS, FIELD_BIOME_TEXTURES} from '../../../configs/fieldBiomeEffects';
import {TWO_PI, pick, randomIn, randomInt, toRadians, writePose} from './biomeMath';

/**
 * ЛИСТЬЯ НА ВЕТРУ — общие для порыва над лугом (./windGust) и вуалей ветра
 * над лугами (./windVeils). Чистые функции без Phaser и DOM.
 *
 * Лист летит над отрядами (слой AIR), качается поперек ветра, кружится и
 * трепещет — поворачивается ребром. Здесь — то, что у листа свое: его числа,
 * качание и кадр. Куда лист несет (путь порыва или вуали), решает построитель
 * эффекта: он считает место листа и зовет writeGustLeafPose.
 *
 * Числа листьев — configs/biomeEffects/windGust (leaves).
 */

/** Вид частицы «лист» */
export const GUST_LEAF = 'leaf';

/**
 * Листья одного порыва. acrossShare и alongShare — место листа в пятне порыва,
 * от -0.5 до 0.5 его размера поперек ветра и вдоль него; speedShare — скорость
 * листа в долях скорости порыва
 */
export const createGustLeaves = (rng, leaves, hexSize) => {
  const particles = [];
  const leafCount = randomInt(rng, leaves.count.min, leaves.count.max);
  // Зеленых — заданная доля: зелень видна в каждом порыве, а не как повезет
  const greenCount = Math.round(leafCount * randomIn(rng, leaves.greenShare));
  for (let index = 0; index < leafCount; index += 1) {
    particles.push({
      kind: GUST_LEAF,
      layer: FIELD_BIOME_LAYER_KEYS.AIR,
      texture: FIELD_BIOME_TEXTURES.LEAF,
      tint: pick(rng, index < greenCount ? leaves.greenTints : leaves.tints),
      acrossShare: rng() - 0.5,
      alongShare: rng() - 0.5,
      speedShare: randomIn(rng, leaves.speedShare),
      length: hexSize * randomIn(rng, leaves.lengthFactor),
      sway: hexSize * randomIn(rng, leaves.swayFactor),
      swayPeriodMs: randomIn(rng, leaves.swayPeriodMs),
      swayPhase: rng() * TWO_PI,
      spinRadPerMs: toRadians(randomIn(rng, leaves.spinDegPerSecond)) / 1000 * (rng() < 0.5 ? 1 : -1),
      spinPhase: rng() * TWO_PI,
      flutterHz: randomIn(rng, leaves.flutterHz),
      flutterPhase: rng() * TWO_PI,
    });
  }
  return particles;
};

/** На сколько лист качнулся поперек ветра к этому моменту */
export const resolveGustLeafSway = (particle, elapsedMs) => (
  particle.sway * Math.sin((TWO_PI * elapsedMs) / particle.swayPeriodMs + particle.swayPhase)
);

/** Кадр листа в данном месте: лист кружится и трепещет */
export const writeGustLeafPose = (out, leaves, particle, x, y, alpha, elapsedMs) => {
  const flutter = 0.5 + 0.5 * Math.sin((TWO_PI * particle.flutterHz * elapsedMs) / 1000 + particle.flutterPhase);
  return writePose(
    out,
    x,
    y,
    alpha,
    particle.length,
    // Трепет: лист поворачивается ребром
    (particle.length / 2) * (1 - leaves.flutterDepth * flutter),
    particle.spinPhase + particle.spinRadPerMs * elapsedMs
  );
};
